import { Switch } from "antd";
import { ButtonH } from "components/UiKit/ButtonH";
import { HorizontalSlider } from "components/elements/HorizontalSlider";
import { Ico } from "components/Uikit";
import { PopoverH } from "components/UiKit/PopoverH";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAudioStateContext } from "hooks/useAudioStateContext";
import { useAudioHandlesContext } from "hooks/useAudioHandlesContext";
import { useIsEnglishUi } from "utils/uiLanguage";

interface VoicingSettingsProps {
    setOpen: (val: boolean) => void;
    setOpenDownload: (val: boolean) => void;
}

export const VoicingSettings = ({ setOpen, setOpenDownload }: VoicingSettingsProps) => {
    const navigate = useNavigate();
    const location = useLocation();
    const en = useIsEnglishUi();
    const state = useAudioStateContext();
    const handles = useAudioHandlesContext();

    const [voicingSpacesMinimum, setVoicingSpacesMinimum] = useState(state.voicingSpacesMinimum);
    const [voicingSpacesMinimumOffset, setVoicingSpacesMinimumOffset] = useState(
        state.voicingSpacesMinimumOffset,
    );

    useEffect(() => {
        setVoicingSpacesMinimum(state.voicingSpacesMinimum);
    }, [state.voicingSpacesMinimum]);

    useEffect(() => {
        setVoicingSpacesMinimumOffset(state.voicingSpacesMinimumOffset);
    }, [state["voicingSpacesMinimumOffset"]]);

    const saveSpacesMinimum = (val: number) => {
        // setVoicingSpacesMinimum(val);
        localStorage.setItem("voicingSpacesMinimum", val.toString());
        handles.setVoicingSpacesMinimum(val);
    };

    const saveSpacesMinimumOffset = (val: number) => {
        localStorage.setItem("voicingSpacesMinimumOffset", val.toString());
        handles.setVoicingSpacesMinimumOffset(val);
    };

    const toggleVoicing = (val: boolean) => {
        const searchParams = new URLSearchParams(location.search);
        searchParams.set("voicing", val ? "1" : "0");
        navigate(`${location.pathname}?${searchParams.toString()}`);
    };

    const handleCut = () => {
        setOpen(true);
    };

    const handleDownloadCatVideo = () => {
        setOpenDownload(true);
    };

    return (
        <PopoverH
            placement="top"
            title={
                <div className="_fv _fgap2 _f100">
                    <div className="_f _f100">
                        <Switch
                            defaultChecked={state["voicingSpacesOn"]}
                            onChange={toggleVoicing}
                        />{" "}
                        {en ? "Remove pauses" : "Удалять паузы"}
                    </div>

                    <ButtonH
                        ghost={!state.voicingSpacesOn}
                        inactive={!state.voicingSpacesOn}
                        disabled={!state.voicingSpacesOn}
                        onClick={handleCut}
                    >
                        {en ? "Cut the pauses out" : "Вырезать паузы"}
                    </ButtonH>

                    <ButtonH
                        ghost={!state.catVideoFolderUrl[state.folder]}
                        inactive={!state.catVideoFolderUrl[state.folder]}
                        disabled={!state.catVideoFolderUrl[state.folder]}
                        onClick={handleDownloadCatVideo}
                    >
                        {en ? "Download video" : "Скачать видео"}
                    </ButtonH>

                    <div
                        className="_fv _f100 _r04 _pd1"
                        style={{ backgroundColor: "rgb(233,233,233)" }}
                    >
                        <div className="">
                            {en ? "Shortest pause" : "Минимальная пауза"}:{" "}
                            {(voicingSpacesMinimum / 1000).toFixed(1)} {en ? "sec" : "с"}
                        </div>
                        <div className="_f100">
                            <div>0</div>
                            <HorizontalSlider
                                value={voicingSpacesMinimum}
                                min={0}
                                max={30000}
                                width={200}
                                step={100}
                                onValueChange={(val: number) => setVoicingSpacesMinimum(val)}
                            />
                            <div>30 {en ? "sec" : "с"}</div>
                        </div>

                        <div className="_f100 _fcc">
                            <ButtonH
                                ghost={voicingSpacesMinimum === state["voicingSpacesMinimum"]}
                                inactive={voicingSpacesMinimum === state["voicingSpacesMinimum"]}
                                disabled={voicingSpacesMinimum === state["voicingSpacesMinimum"]}
                                onClick={() => saveSpacesMinimum(voicingSpacesMinimum)}
                            >
                                {en ? "Apply" : "Применить"}
                            </ButtonH>
                            <ButtonH
                                style={{
                                    opacity:
                                        voicingSpacesMinimum === state["voicingSpacesMinimum"]
                                            ? 0.4
                                            : 1,
                                }}
                                inactive={voicingSpacesMinimum === state["voicingSpacesMinimum"]}
                                disabled={voicingSpacesMinimum === state["voicingSpacesMinimum"]}
                                ghost={true}
                                onClick={() =>
                                    setVoicingSpacesMinimum(state["voicingSpacesMinimum"])
                                }
                            >
                                <Ico size={"16"}>undo</Ico>
                            </ButtonH>
                        </div>
                    </div>

                    <div
                        className="_fv _f100 _r04 _pd1"
                        style={{ backgroundColor: "rgb(233,233,233)" }}
                    >
                        <div className="">
                            {en ? "Cut margins" : "Отступы при вырезании"}:{" "}
                            {(voicingSpacesMinimumOffset / 1000).toFixed(1)} {en ? "sec" : "с"}
                        </div>
                        <div className="_f100">
                            <div>0</div>
                            <HorizontalSlider
                                value={voicingSpacesMinimumOffset}
                                min={0}
                                max={3000}
                                width={200}
                                step={100}
                                onValueChange={(val: number) => setVoicingSpacesMinimumOffset(val)}
                            />
                            <div>3 {en ? "sec" : "с"}</div>
                        </div>

                        <div className="_f100 _fcc">
                            <ButtonH
                                ghost={
                                    voicingSpacesMinimumOffset ===
                                    state["voicingSpacesMinimumOffset"]
                                }
                                inactive={
                                    voicingSpacesMinimumOffset ===
                                    state["voicingSpacesMinimumOffset"]
                                }
                                disabled={
                                    voicingSpacesMinimumOffset ===
                                    state["voicingSpacesMinimumOffset"]
                                }
                                onClick={() => saveSpacesMinimumOffset(voicingSpacesMinimumOffset)}
                            >
                                {en ? "Apply" : "Применить"}
                            </ButtonH>
                            <ButtonH
                                style={{
                                    opacity:
                                        voicingSpacesMinimumOffset ===
                                        state["voicingSpacesMinimumOffset"]
                                            ? 0.4
                                            : 1,
                                }}
                                inactive={
                                    voicingSpacesMinimumOffset ===
                                    state["voicingSpacesMinimumOffset"]
                                }
                                disabled={
                                    voicingSpacesMinimumOffset ===
                                    state["voicingSpacesMinimumOffset"]
                                }
                                ghost={true}
                                onClick={() =>
                                    setVoicingSpacesMinimumOffset(
                                        state["voicingSpacesMinimumOffset"],
                                    )
                                }
                            >
                                <Ico size={"16"}>undo</Ico>
                            </ButtonH>
                        </div>
                    </div>
                </div>
            }
        >
            <ButtonH sm ghost>
                <Ico size={"16"}>settings</Ico>
                {en ? "Configure" : "Настроить"}
            </ButtonH>
        </PopoverH>
    );
};
